export const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-zA-Z])(.*)$/;
export const PHONE_REGEX = /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/;
export const DATE_FORMAT = 'YYYY-MM-DD';
export const BULLETIN_CODE_REGEX = /(^\d{2}[\dA-C](?:[0-2]\d|3[0-1])[0A-Z][0-9A-Z]{4})$/;
export const CNP_PATTERN = /^([1-8])(\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{6}$/;
